import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const routes = [
  {
    name: "cps",
    path: "/cps",
    component: () => import("./pages/cps/views/index.vue"),
    redirect: "/cps/management",
    children: [
      {
        path: "management",
        name: "management",
        component: () => import("./pages/cps/views/management.vue"),
        meta: { title: "签约宝数据概览" }
      },
      {
        path: "profile",
        name: "profile",
        component: () => import("./pages/cps/views/profile.vue"),
        meta: { title: "合作管理" }
      },
      {
        path: "order",
        name: "order",
        component: () => import("./pages/cps/views/order.vue"),
        meta: { title: "前去提单" }
      }
    ]
  },
  {
    name: "cpsInfo",
    path: "/cpsInfo",
    component: () => import("./pages/cps/views/poster.vue"),
    meta: { title: "签约宝介绍" }
  },
  {
    name: "pearlAcrossCircle",
    path: "/pearl/acrossCircle",
    component: () => import("./pages/pearl/views/acrossCircle.vue"),
    meta: { title: "跨商圈直升机" }
  },
  {
    name: "pearlAcrossCircleDetail",
    path: "/pearl/acrossCircle/detail",
    component: () => import("./pages/pearl/views/acrossCircleDetail.vue"),
    meta: { title: "商品详情" }
  },
  {
    name: "cpsCity",
    path: "/cps/city",
    component: () => import("./pages/cps/views/cpsCity.vue"),
    meta: { title: "修改城市(可多选)" }
  },
  {
    name: "pearlDiscountTypeSet",
    path: "/pearl/discount/type",
    component: () => import("./pages/pearl/views/discountTypeSet.vue"),
    meta: { title: "优惠方式设置" }
  },
  {
    name: "pearlRecharge",
    path: "/pearl/recharge",
    component: () => import("./pages/pearl/views/pearlRecharge.vue"),
    meta: { title: "珍珠点充值" }
  },
  {
    name: "pearlOrder",
    path: "/pearl/order",
    component: () => import("./pages/pearl/views/pearlOrder.vue"),
    meta: { title: "订单支付" }
  },
  {
    name: "pdfview",
    path: "/contract/pdfview",
    component: () => import("./pages/contract/pdfview/views/pdfView.vue"),
    meta: { title: "合同预览" }
  },
  {
    name: "contractOfLessee",
    path: "/contract/lessee",
    component: () => import("./pages/contract/lessee/views/contractInput.vue"),
    meta: { title: "租约登记（1/2）", keepAlive: true }
  },
  {
    name: "billList",
    path: "/contract/billlist",
    component: () => import("./pages/contract/lessee/views/billList.vue"),
    meta: { title: "账单预览（2/2）" }
  },
  {
    name: "contractOfLesseeRenew",
    path: "/contract/lesseerenew",
    component: () => import("./pages/contract/lessee/views/contractRenew.vue"),
    meta: { title: "续租登记（1/2）", keepAlive: true }
  },
  {
    name: "billListRenew",
    path: "/contract/billlistrenew",
    component: () => import("./pages/contract/lessee/views/billListRenew.vue"),
    meta: { title: "账单预览（2/2）" }
  },
  {
    name: "propertyInput",
    path: "/contract/propertyinput",
    component: () =>
      import("./pages/contract/lessee/views/new_propertyInput.vue"),
    meta: { title: "编辑物业交割清单" }
  },
  {
    name: "propertyPreview",
    path: "/contract/propertyPreview",
    component: () =>
      import("./pages/contract/lessee/views/propertyPreview.vue"),
    meta: { title: "物业交割清单" }
  },
  {
    name: "checkInPersonAdd",
    path: "/contract/checkInPersonAdd",
    component: () =>
      import("./pages/contract/lessee/views/checkInPersonAdd.vue"),
    meta: { title: "入住人" }
  },
  {
    name: "checkInPersonView",
    path: "/contract/checkInPersonView",
    component: () =>
      import("./pages/contract/lessee/views/checkInPersonView.vue"),
    meta: { title: "入住人" }
  },
  {
    name: "emergencyContactAdd",
    path: "/contract/emergencyContactAdd",
    component: () =>
      import("./pages/contract/lessee/views/emergencyContactAdd.vue"),
    meta: { title: "紧急联系人" }
  },
  {
    name: "emergencyContactView",
    path: "/contract/emergencyContactView",
    component: () =>
      import("./pages/contract/lessee/views/emergencyContactView.vue"),
    meta: { title: "紧急联系人" }
  },
  {
    name: "contractSuccess",
    path: "/contract/success",
    component: () => import("./pages/contract/lessee/views/success.vue"),
    meta: { title: "合同创建成功" }
  },
  {
    name: "subsidy",
    path: "/subsidy",
    component: () => import("./pages/subsidy/views/subsidy.vue"),
    meta: { title: "居住津贴核销" }
  },
  {
    name: "juejinConfirm",
    path: "/juejin/confirm",
    component: () => import("./pages/juejin/views/confirm.vue"),
    meta: { title: "企业联系人身份确认" }
  },
  {
    name: "newYouthWriteOff",
    path: "/newYouth/writeOff",
    component: () => import("./pages/newYouth/views/WriteOff.vue"),
    meta: { title: "活动券核销" }
  },
  {
    name: "newYouthCouponRecord",
    path: "/newYouth/couponRecord",
    component: () => import("./pages/newYouth/views/couponRecord.vue"),
    meta: { title: "活动审核" }
  },
  {
    name: "newYouthCouponRecordDemo",
    path: "/newYouth/couponRecordDemo",
    component: () => import("./pages/newYouth/views/couponRecordDemo.vue"),
    meta: { title: "示例" }
  },
  {
    name: "newYouthCouponRecordHistory",
    path: "/newYouth/couponRecordHistory",
    component: () => import("./pages/newYouth/views/couponRecordHistory.vue"),
    meta: { title: "历史记录" }
  },
  {
    name: "positionStatusSwitch",
    path: "/position/switch",
    component: () => import("./pages/position/views/statusSwitch.vue"),
    meta: { title: "展位开关" }
  },
  {
    name: "agentScoreRule",
    path: "/agent/rule",
    component: () => import("./pages/agentScore/views/agentScoreRule.vue"),
    meta: { title: "规则说明" }
  },
  {
    name: "agentScoreRecharge",
    path: "/agent/recharge",
    component: () => import("./pages/agentScore/views/agentScoreRecharge.vue"),
    meta: { title: "代出点充值" }
  },
  {
    name: "agentScoreDetail",
    path: "/agent/detail",
    component: () => import("./pages/agentScore/views/agentScoreDetail.vue"),
    meta: { title: "代出点明细" }
  },
  {
    name: "pearlIndex",
    path: "/pearl/index",
    component: () => import("./pages/pearl/views/pearlIndex.vue"),
    meta: { title: "账户" }
  },
  {
    name: "pearlBrandCar",
    path: "/pearl/brandCar",
    component: () => import("./pages/pearl/views/brandCar.vue"),
    meta: { title: "品牌直通车" }
  },
  {
    name: "pearlAuctionDetail",
    path: "/pearl/auction/detail",
    component: () => import("./pages/pearl/views/auctionDetail.vue"),
    meta: { title: "商品详情" }
  },
  {
    name: "privacyAgreement",
    path: "/privacy/agreement",
    component: () => import("./pages/privacy/views/agreement.vue"),
    meta: { title: "用户隐私与规则中心" }
  },
  {
    name: "privacyDocument",
    path: "/privacy/document",
    component: () => import("./pages/privacy/views/document.vue"),
    meta: { title: "协议" }
  },
  {
    name: "identityRule",
    path: "/identity/rule",
    component: () => import("./pages/privacy/views/identityRule.vue"),
    meta: { title: "规则" }
  },
  {
    name: "noticeDetail",
    path: "/notice/detail",
    component: () => import("./pages/notice/views/noticeDetail.vue"),
    meta: { title: "公告" }
  },
  {
    path: "*",
    component: () => import("./pages/common/views/404.vue"),
    props: { errorType: "404" }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({
  mode: "history",
  base: "channel_page_v2",
  routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
    window.$ljBridge &&
      window.$ljBridge.ready((bridge, webStatus) => {
        bridge.setPageTitle(title);
      });
  }
  next();
});

export { router };
